<!-- 打印预览 -->
<template>
  <div class="container containerBox">打印预览
  </div>
</template>

<script>
export default {
  name:'printpreview',
  data () {
    return {
    };
  },

  methods: {
    
  }
}

</script>
<style lang='css' scoped>
</style>